import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { interesesController } from 'src/app/controller/intereses/agregar-intereses-controller';
import { AgregarInteresesModalComponent } from 'src/app/paginas/acuerdos-pago/agregar-intereses-modal/agregar-intereses-modal.component';

@Component({
  selector: 'app-agregar-intereses',
  templateUrl: './agregar-intereses.component.html',
  styleUrls: ['./agregar-intereses.component.scss']
})
export class AgregarInteresesComponent {
  interestsForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private _interesesController: interesesController,
    public dialogRef: MatDialogRef<AgregarInteresesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.interestsForm = this.fb.group({
      interestsForm: [null, [Validators.required, Validators.min(0)]],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if(this.interestsForm.valid) {
     /*  this._interesesController.agregarInteres(this); */
      this.dialogRef.close({guardado:true});
    }
  }


    onlyNumbers(event: KeyboardEvent): void {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }

  blockPasteNegative(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text') ?? '';
    if (/[^0-9]/.test(pastedData)) {
      event.preventDefault();
    }
  }
}
